import { api } from "@/lib/api";
import type { Organization, OrganizationMember } from "@/types";

export async function checkOrgSlug(slug: string) {
  return api.get<{ available: boolean; slug: string }>(`/organizations/check-slug/${slug}`);
}

export async function getCurrentOrg() {
  return api.get<Organization & { role: string }>("/organizations/current");
}

export async function createOrg(data: { name: string; slug: string }) {
  return api.post<Organization>("/organizations", data);
}

export async function getOrg(id: string) {
  return api.get<Organization & { memberCount: number; competitionCount: number }>(
    `/organizations/${id}`,
  );
}

export async function updateOrg(id: string, data: { name?: string; slug?: string }) {
  return api.patch(`/organizations/${id}`, data);
}

export async function deleteOrg(id: string) {
  return api.delete(`/organizations/${id}`);
}

export async function getOrgMembers(id: string) {
  return api.get<OrganizationMember[]>(`/organizations/${id}/members`);
}

export async function addOrgMember(id: string, targetUserId: string) {
  return api.post(`/organizations/${id}/members`, { targetUserId });
}

export async function removeOrgMember(id: string, targetUserId: string) {
  return api.delete(`/organizations/${id}/members/${targetUserId}`);
}

export async function updateOrgMemberRole(id: string, targetUserId: string, role: string) {
  return api.patch(`/organizations/${id}/members/${targetUserId}/role`, { role });
}

export async function leaveOrg(id: string) {
  return api.post(`/organizations/${id}/leave`);
}

export async function transferOrgOwnership(id: string, targetUserId: string) {
  return api.post(`/organizations/${id}/transfer-ownership`, { targetUserId });
}

export async function searchOrgUsers(id: string, query: string) {
  return api.get<{ userId: string; username: string; displayName: string }[]>(
    `/organizations/${id}/search-users?q=${encodeURIComponent(query)}`,
  );
}

export async function getOrgCompetitions(id: string) {
  return api.get<
    {
      id: string;
      name: string;
      type: string;
      startsAt: string;
      endsAt: string;
      memberCount: number;
      createdAt: string;
    }[]
  >(`/organizations/${id}/competitions`);
}
